import { environment } from "../../environments/environment";

export class Constant {
  //Header config
  public static header_config_code = "Fmarket";
  public static site_key_recaptcha = environment.capcha;
  public static account_firebase = "lhphuong86.finanma@gmail.com";
  public static password_firebase = "finandesk-firebase";
  public static key_root_product_firebase = "/product/";
  //URL
  public static url_host = environment.urlBackEnd + environment.portBackEnd;
  public static url_host_blog = environment.urlBackEndBlog;
  public static url_asset = environment.asset;
  public static url_lib_phone = environment.asset + "/assets/lib/js/intlTelInput/utils.js";
  public static url_host_upload = environment.urlUploadBackEnd;
  public static url_facebook = "https://www.facebook.com/fmarket";
  public static url_twitter = "https://twitter.com/fmarket";
  public static url_youtube = "https://youtube.com/fmarket";

  //TODO Icon s3
  public static icon_url_images = environment.asset + "/assets/images/";
  public static icon_url_local_host = environment.asset + "/assets/images/icon/";
  public static icon_url_host = "/assets/images/icon/";
  public static images_url_host = environment.asset + "/assets/images/";
  public static logo_url_host = "/assets/images/logo/";
  public static icon_503_host = "/assets/images/503/";
  public static icon_url_pre = Constant.icon_url_host + "arrow-l.png";
  public static icon_url_next = Constant.icon_url_host + "arrow-r.png";
  public static icon_url_convert = Constant.icon_url_host + "arrow.svg";
  public static icon_url_pdf = Constant.icon_url_host + "pdf.svg";
  public static icon_url_pdf_icon = Constant.icon_url_host + "pdf_icon.png";
  public static icon_url_excel = Constant.icon_url_host + "excel.svg";
  public static icon_url_xls_icon = Constant.icon_url_host + "xls_icon.png";
  public static icon_url_no_data = Constant.icon_url_host + "nodata.png";
  public static icon_url_add = Constant.icon_url_host + "add.svg";
  public static icon_url_remove = Constant.icon_url_host + "delete-table.svg";
  public static icon_url_remove_table = Constant.icon_url_host + "delete-table.png";
  public static icon_url_pencil = Constant.icon_url_host + "butchi.svg";
  public static icon_url_copy = Constant.icon_url_host + "copy.svg";
  public static icon_url_notice = Constant.icon_url_host + "notice.png";
  public static icon_url_pay_ment = Constant.icon_url_host + "thanh-toan.svg";
  public static icon_url_files = Constant.icon_url_host + "files.svg";
  public static icon_url_withdrawal = Constant.icon_url_host + "withdrawal.svg";
  public static icon_url_user = Constant.icon_url_host + "user.svg";
  public static icon_url_user_id = Constant.icon_url_host + "iconID.svg";
  public static icon_url_payment = Constant.icon_url_host + "payment.svg";
  public static icon_url_fail = Constant.icon_url_host + "error.svg";
  public static icon_url_fails = Constant.icon_url_host + "error.svg";
  public static icon_url_success = Constant.icon_url_host + "success-bg.svg";
  public static icon_url_white_success = Constant.icon_url_host + "success.svg";
  public static icon_url_reupload = Constant.icon_url_host + "Reuplpad.png";
  public static icon_url_close_modal = Constant.icon_url_host + "close-modal.png";
  public static icon_url_minimisize = Constant.icon_url_host + "minisize.png";
  public static icon_url_toolchat = Constant.icon_url_host + "callme.png";
  public static icon_url_viewmore = Constant.icon_url_host + "viewmore.svg";
  public static icon_url_twitter = Constant.icon_url_host + "TWITTER.svg";
  public static icon_url_viber = Constant.icon_url_host + "VIBER.svg";
  public static icon_url_skype = Constant.icon_url_host + "SKYPE.svg";
  public static icon_url_messenger = Constant.icon_url_host + "MESSENGER.svg";
  public static icon_url_youtube = Constant.icon_url_host + "YOUTUBE.svg";
  public static icon_url_facebook = Constant.icon_url_host + "FACEBOOK.svg";
  public static icon_url_blog_fb = Constant.icon_url_host + "fb.svg";
  public static icon_url_blog_yt = Constant.icon_url_host + "ytb.svg";
  public static icon_files = Constant.icon_url_host + "files.svg";
  public static icon_down = Constant.icon_url_host + "download.png";
  public static icon_user = Constant.icon_url_host + "user.svg";
  public static icon_check = Constant.icon_url_host + "check.svg";
  public static icon_sinhloi = Constant.icon_url_host + "sinhloi.svg";
  public static icon_robot = Constant.icon_url_host + "robot.svg";
  public static icon_mienphi = Constant.icon_url_host + "mienphi.svg";
  public static icon_platform = Constant.icon_url_host + "platform.png";
  public static img_solution = Constant.icon_url_host + "solution.png";
  public static icon_url_fa_global = Constant.icon_url_host + "icon-global.svg";
  public static icon_url_fa_mail = Constant.icon_url_host + "icon-mail.svg";
  public static icon_url_fa_marker = Constant.icon_url_host + "icon-marker.svg";
  public static icon_url_fa_phone = Constant.icon_url_host + "icon-phone.svg";
  public static logo_blog_url_host = Constant.logo_url_host + "blog.png";
  public static giay_gdtt_url_host = Constant.logo_url_host + "giay-dk-gdtt.pdf";
  public static logo_no_connect_internet = Constant.icon_503_host + "Disconnect.png";
  //bank logo
  public static logo_vietcombank = Constant.logo_url_host + "vcb.png";
  public static logo_techcom = Constant.logo_url_host + "tcb.png";
  public static logo_tpbank = Constant.logo_url_host + "tpb.png";
  public static logo_vpbank = Constant.logo_url_host + "vpb.png";
  public static logo_mbbank = Constant.logo_url_host + "mb.png";
  public static logo_vietinbank = Constant.logo_url_host + "vtb.png";
  public static logo_bidv = Constant.logo_url_host + "bidv.png";
  public static logo_lienvietbank = Constant.logo_url_host + "lvb.png";
  public static logo_acb = Constant.logo_url_host + "acb.png";
  public static logo_hdank = Constant.logo_url_host + "hdb.png";
  public static logo_shb = Constant.logo_url_host + "shb.png";
  public static logo_vib = Constant.logo_url_host + "vib.png";
  public static logo_seabank = Constant.logo_url_host + "sb.png";
  public static logo_sacombank = Constant.logo_url_host + "scb.png";
  public static logo_pvbank = Constant.logo_url_host + "pvb.png";
  public static logo_argbank = Constant.logo_url_host + "agrb.png";
  public static logo_anzbank = Constant.logo_url_host + "anz.png";
  public static logo_citibank = Constant.logo_url_host + "citib.png";
  public static logo_dongabank = Constant.logo_url_host + "donga.png";
  public static logo_eximbank = Constant.logo_url_host + "exim.png";
  public static logo_hsbcbank = Constant.logo_url_host + "hsbc.png";
  public static logo_maritimebank = Constant.logo_url_host + "maritime.png";
  public static logo_shinhanbank = Constant.logo_url_host + "shinhan.png";
  public static logo_standardbank = Constant.logo_url_host + "standard.png";
  public static logo_ocbbank = Constant.logo_url_host + "ocbbank.png";

  public static logo_scbbank = Constant.logo_url_host + "scbbank.png";
  public static logo_kienlongbank = Constant.logo_url_host + "kienlongbank.png";
  public static logo_ncbbank = Constant.logo_url_host + "ncbbank.png";
  public static logo_vietabank = Constant.logo_url_host + "vietabank.png";
  public static logo_oceanbank = Constant.logo_url_host + "oceanbank.png";
  public static logo_abbank = Constant.logo_url_host + "abbank.png";
  public static logo_cbbank = Constant.logo_url_host + "cbbank.png";
  public static logo_baovietbank = Constant.logo_url_host + "baoviet.png";
  public static logo_ivbbank = Constant.logo_url_host + "ivb.png";
  public static logo_pgbank = Constant.logo_url_host + "pgbank.png";
  public static logo_vietbank = Constant.logo_url_host + "vietbank.png";
  public static logo_vietcapitalbank = Constant.logo_url_host + "vietcapital.png";
  public static logo_vrbbank = Constant.logo_url_host + "vrb.png";
  public static logo_namabank = Constant.logo_url_host + "namabank.png";
  public static logo_bacabank = Constant.logo_url_host + "bacabank.png";

  //user code
  public static code_investor = "investor";
  public static CODE_INVESTOR = "INVESTOR";
  public static CODE_INVESTOR_PERSONAL = "INVESTOR_PERSONAL";
  public static CODE_INVESTOR_ORGANIZATION = "INVESTOR_ORGANIZATION";
  public static code_issuer = "issuer";
  public static CODE_ISSUER = "ISSUER";
  public static CODE_AGENT = "AGENT";

  //user status code
  public static status_first_login = "USER_FIRST_LOGIN";
  public static status_user_pending = "USER_PENDING";
  public static STATUS_PRODUCT_PENDING = "PRODUCT_PENDING";
  public static STATUS_PRODUCT_APPROVED = "PRODUCT_APPROVED";
  public static STATUS_PRODUCT_DRAFT = "PRODUCT_DRAFT";

  //path
  public static path_dashboard = "dashboard";
  public static path_home = "home-dashboard";
  public static path_resource = "res";
  public static path_issuers = "issuers";
  public static path_general = "general";
  public static path_support = "support";
  public static path_contact = "contact";
  public static path_promotion = "promotion";
  public static path_aboutUs = "aboutUs";
  public static path_calculate_invest = "calculate-invest";
  public static path_fmarketPlatform = "fmarketPlatform";
  public static path_how_it_work = "howItWork";
  public static path_detail_portfolio = "portfolio";
  public static path_blog = "blog";
  public static path_type = "type";
  public static path_knowledge = "knowledge";
  public static path_story = "story";
  public static path_news = "news";
  public static path_detail_blog = "detail";
  public static path_page_blog = "page";
  public static path_products = "products";
  public static path_products_home = "san_pham";
  public static path_legal = "legal";
  public static path_term = "term";
  public static path_our_story = "our-story";
  public static path_account = "account";
  public static path_auth = "auth";
  public static path_login = "login";
  public static path_introduce_app = "introduce-app";
  public static path_ekyc = "ekyc";
  public static path_login_success = "login-success";
  public static path_forgot = "forgot";
  public static path_profile = "profile";
  public static path_register_trade = "register-trade";
  public static path_roboF = "robo";
  public static path_change_pass = "change-password";
  public static path_change_email = "change-email";
  public static path_change_phone = "change-phone";
  public static path_first_login = "required";
  public static path_active = "activation";
  public static path_change = "change";
  public static path_active_success = "success";
  public static path_active_fail = "fail";
  public static path_change_mail_success = "change-mail/success";
  public static path_change_mail_fail = "change-mail/fail";
  public static path_active_reset_pass = "reset-password";
  public static path_active_unfollow = "unfollow";
  public static path_register_investor = "signUp";
  public static path_register_issuer = "signUp/" + Constant.code_issuer;
  //Path investor
  public static path_market = "market";
  public static path_fund = "fund";
  public static path_gold = "gold";
  public static path_nav = "nav";
  public static path_sip = "sip";
  public static path_list = "list";
  public static path_edit = "edit";
  public static path_received_profile = "received_profile";
  public static path_transaction_management = "transaction-management";
  public static path_pending_transaction = "pending-transactions";

  public static path_buy_transaction = "buy-transactions";
  public static path_sell_transaction = "sell-transactions";
  public static path_transfer_buy_transaction = "transfer-buy-transactions";
  public static path_transfer_sell_transaction = "transfer-sell-transactions";
  public static path_withdraw_transaction = "withdraw-transactions";

  public static path_detail_transaction = "detail-transactions";

  public static path_import_file_transaction = "import-file-transactions";
  public static path_new_transaction = "new-transactions";
  public static path_check_status = "check-status";

  public static path_history_transaction = "history-transactions";
  public static path_transfer_asset = "transfer-asset";
  public static path_statistic_transaction = "statistic-transactions";
  public static path_admin_transaction = "admin-transactions";
  public static path_reconcile_transactions = "reconcile-transactions";
  public static path_reconcile_agent_transaction_tabs = "reconcile-agent-transactions-tabs";
  public static path_reconcile_vsd_transaction_tabs = "reconcile-vsd-transactions-tabs";
  public static path_history_reconcile_transaction = "history-reconcile-transactions";
  public static path_investors = "investors";
  public static path_investors_register_sip = "register-sip";
  public static path_investors_change_profile = "change-profile";
  public static path_investors_change_name = "change-name";

  public static path_user_documents = "user-documents";
  public static path_kyc = "kyc";
  public static path_kyc_for_foreign = "kyc_for_foreign";
  public static path_vsd = "vsd";
  public static path_approved_kyc_profile = "approved-kyc-profile";
  public static path_pending_profile_on_vsd = "pending-profile-on-vsd";
  public static path_profile_on_vsd = "profile_on_vsd";
  public static path_asset_report = "asset-report";
  public static path_fee_report = "fee-report";
  public static path_fee_report_issuer = "fee-report-for-issuer";
  public static path_fee_report_agent = "fee-report-for-agent";
  public static path_list_not_updated_investors = "list-not-updated-investors";
  public static path_survey_ipo = "survey_ipo";
  public static path_list_ekyc_logs = "list-ekyc-logs";
  public static path_list_ekyc_manual = "list-ekyc-manual";

  public static path_change_information = "change-information";
  public static path_change_information_bank = "change-information-bank";
  public static path_change_information_idCard = "change-information-idCard";
  public static path_change_information_phone = "change-information-phone";
  public static path_change_information_email = "change-information-email";
  public static path_change_information_private = "change-information-private";
  public static path_change_information_sign = "change-information-sign";
  public static path_export_fatca = "export-fatca";

  public static path_transaction_management_issuer = "transactions";
  public static path_asset_management = "asset";
  public static path_report = "report";
  public static path_help = "help";
  public static path_profile_investor = "profile-investor";
  public static path_product = "product";
  //Path issuer
  public static path_portfolio = "products";
  public static path_create_product = "create";
  public static path_create_bonds = "create-bonds";
  public static path_create_new_fund = "create-new-fund";
  public static path_create_gold = "./gold/create";
  public static path_create_certificate_deposit = "create-certificate-deposit";
  public static path_create_trading_fund = "create-trading-fund";
  public static path_transaction = "transaction";
  public static path_reconcile = "reconcile";
  public static path_money_transaction = "money-transaction";
  public static path_issuer_report = "report";
  public static path_issuer_agency = "agency";
  public static path_user_doc = "user-doc";
  public static path_change_profile = "change-profile";
  public static path_register_sip = "register-sip";
  public static path_tools = "tools";
  public static path_split_pdf = "split-pdf";
  public static path_check_asset = "check-asset";
  public static path_export_suggest_auto_payment = "export-suggest-auto-payment";

  //Path agen
  public static code_agent = "agent";

  //URL module
  public static url_module_dashboard = "./dashboard/dashboard.module#DashboardModule";
  public static url_module_main = "./main/main.module#MainModule";
  public static url_module_auth = "./authorization/auth.module#AuthModule";
  public static url_module_main_investor = "./investor/investor.module#InvestorModule";
  public static url_module_main_issuer = "./issuer/issuer.module#IssuerModule";
  public static url_module_main_agent = "./agent/agent.module#AgentModule";
  public static url_module_active_mail = "./active-mail/active-mail.module#ActiveMailModule";
  public static url_module_change_mail = "./change-mail/change-mail.module#ChangeMailModule";

  //URL screen
  public static route_profile_investor = "/account/investor/profile";
  public static route_change_password = "/account/investor/" + Constant.path_change_pass;
  public static route_change_email = "/account/investor/" + Constant.path_change_email;
  public static route_change_phone = "/account/investor/" + Constant.path_change_phone;

  //Tab investor market
  public static tab_market = "dashboard";
  public static tab_trading_order = "trading-order";
  public static tab_transaction_history = "transaction-history";

  //Tab money transaction
  public static tab_withdrawal = "withdrawal";
  public static tab_withdrawal_order = "withdrawal-order";
  public static tab_cash_statement = "cash-statement";
  public static tab_deposit_guide = "deposit-guide";

  //Tabs portfolio
  public static tab_issued_products = "issuedProduct";
  public static tab_pending_products = "pendingProduct";
  public static tab_list_issuer = "list-investor";
  public static tab_transactions = "transactions";

  //Tabs Transaction history
  public static tab_transaction_detail = "transaction-detail";
  public static tab_register_sip = "register-sip";
  public static tab_transactions_history = "transactions-history";
  public static tab_check_approve_status = "check-approve-status";
  public static tab_transaction_import = "transaction-import";
  public static tab_import_file = "import_file";
  public static tab_pending_trade = "pending_trade";
  public static tab_statistic = "statistic";

  //Tabs user-doc
  public static tab_list_investor = "list-investor";
  public static tab_asset_report = "asset-report";
  public static tab_fee_report = "fee-report";
  public static tab_fee_report_for_issuer = "fee-report-for-issuer";
  public static tab_fee_report_for_partner = "fee-report-for-partner";
  public static tab_pending_profile_on_vsd = "pending-profile-on-vsd";
  public static tab_profile_on_vsd = "profile_on_vsd";
  public static tab_approved_kyc_profile = "approved-kyc-profile";
  public static tab_list_account = "list-account";
  public static tab_list_not_updated_investors = "list-not-updated-investors";
  public static tab_survey_ipo = "survey_ipo";
  public static tab_list_ekyc_logs = "list-ekyc-logs";
  public static tab_list_ekyc_manual = "list-ekyc-manual";

  //Tabs profile
  public static tab_profile = "PROFILE";
  public static tab_second_profile = "second-profile";
  public static tab_register_trade = "register-trade";
  public static tab_information_profile = "information-profile";
  public static tab_bank_profile = "bank-profile";
  public static tab_passport_profile = "passport-profile";
  public static tab_phone_profile = "phone-profile";
  public static tab_mail_profile = "mail-profile";
  public static tab_sign_document_update_profile = "sign-profile";

  //Tabs create
  public static tab_asset_detail_holding = "detail_holding";
  public static tab_asset_tab_category_investor = "category_investor";
  public static tab_asset_tab_recurring_investment = "recurring_investment";

  //Tabs create
  public static tab_create_product = "create";
  public static tab_create_drafts = "drafts";

  //Support
  public static tab_support_kn = "knowledge";
  public static tab_support_qa = "faq";
  public static tab_support_ua = "useApp";

  //legal
  public static tab_legal_terms = "terms";
  public static tab_legal_privacy = "privacy";
  public static tab_legal_disclosures = "disclosures";
  //BLOG
  public static url_blog = "/" + Constant.path_blog;

  //Dashboard
  public static url_home = "/" + Constant.path_home;
  public static url_resource = "/" + Constant.path_resource;
  public static url_support = "/" + Constant.path_support;
  public static url_support_qa = "/" + Constant.path_support + "?tab=faq";
  public static url_contact = "/" + Constant.path_contact;
  public static url_promotion = "/" + Constant.path_promotion;
  public static url_how_it_work = "/" + Constant.path_how_it_work;
  public static url_aboutUs = "/" + Constant.path_aboutUs;
  public static url_detail_portfolio = "/" + Constant.path_detail_portfolio;
  public static url_products = "/" + Constant.path_products;
  public static url_legal = "/" + Constant.path_legal;
  public static url_our_story = "/" + Constant.path_our_story;
  public static url_fmarketPlatform = "/" + Constant.path_fmarketPlatform;
  public static url_issuers = Constant.url_resource + "/" + Constant.path_issuers;
  public static url_dasboard_issuers = "/" + Constant.path_issuers;

  public static url_knowledge = "/" + Constant.path_knowledge;
  public static url_story = "/" + Constant.path_story;
  public static url_news = "/" + Constant.path_news;
  public static url_detail_blog = "/" + Constant.path_detail_blog;

  public static url_reset_pass = "/" +  Constant.path_active + "/" + Constant.path_active_reset_pass;
  public static url_active_mail_success = "/" +  Constant.path_active + "/" + Constant.path_active_success;
  public static url_active_mail_fail = "/" +  Constant.path_active + "/" + Constant.path_active_fail;
  public static url_change_mail_success = "/" +  Constant.path_active + "/" + Constant.path_change_mail_success;
  public static url_change_mail_fail = "/" +  Constant.path_active + "/" + Constant.path_change_mail_fail;
  public static url_active_unfollow = "/" +  Constant.path_active + "/" + Constant.path_active_unfollow;
  public static url_forgot = "/" +  Constant.path_auth + "/" + Constant.path_forgot;
  public static url_login = "/" +  Constant.path_auth + "/" + Constant.path_login;
  public static url_register_investor = "/" +  Constant.path_auth + "/" + Constant.path_register_investor;
  public static url_register_issuer = "/" +  Constant.path_auth + "/" + Constant.path_register_issuer;
  public static url_first_login = "/" +  Constant.path_auth + "/" + Constant.path_first_login;
  public static url_issuer_profile = "/" +  Constant.code_issuer + "/" + Constant.path_profile;
  public static url_investor_profile = "/" + Constant.path_account +  "/" + Constant.code_investor + "/" +  Constant.path_profile;

  public static url_agent_profile = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_profile;
  public static url_issuer_change_pass = "/" +  Constant.code_issuer + "/" + Constant.path_change_pass;
  public static url_investor_change_pass = "/" + Constant.path_account +  "/" + Constant.code_investor + "/" +  Constant.path_change_pass;
  public static url_investor_change_email = "/" + Constant.path_account +  "/" + Constant.code_investor + "/" +  Constant.path_change_email;
  public static url_investor_change_phone = "/" + Constant.path_account +  "/" + Constant.code_investor + "/" +  Constant.path_change_phone;
  public static url_agent_change_pass = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_change_pass;

  //URL issuer
  public static url_issuer = "/" + Constant.code_issuer;
  public static url_issuer_portfolio = Constant.url_issuer + "/" + Constant.path_portfolio;
  public static url_issuer_products = Constant.url_issuer + "/" + Constant.path_products;
  public static url_issuer_pending_products = Constant.url_issuer_products + "/" + Constant.tab_pending_products;
  public static url_issuer_issued_products = Constant.url_issuer_products + "/" + Constant.tab_issued_products;
  public static url_issuer_create_product = Constant.url_issuer + "/" + Constant.path_create_product;
  public static url_issuer_create_bonds = Constant.url_issuer + "/" + Constant.path_create_bonds;
  public static url_issuer_create_new_fund = Constant.url_issuer + "/" + Constant.path_create_new_fund;
  public static url_issuer_create_trading_fund = Constant.url_issuer + "/" + Constant.path_create_trading_fund;
  public static url_issuer_create_certificate_deposit = Constant.url_issuer + "/" + Constant.path_create_certificate_deposit;
  public static url_issuer_transaction = Constant.url_issuer + "/" + Constant.path_transaction;
  public static url_issuer_money = Constant.url_issuer + "/" + Constant.path_money_transaction;
  public static url_issuer_report = Constant.url_issuer + "/" + Constant.path_report;
  public static url_issuer_agency = Constant.url_issuer + "/" + Constant.path_issuer_agency;
  public static url_issuer_help = Constant.url_issuer + "/" + Constant.path_help;
  //URL AGENT
  public static url_agent_transaction = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_transaction;
  public static url_agent_pending_transaction = Constant.url_agent_transaction + "/" + Constant.path_pending_transaction;
  public static url_agent_pending_fund_transaction = Constant.url_agent_transaction + "/" +  Constant.path_pending_transaction + "/" +  Constant.path_fund;
  public static url_agent_pending_gold_transaction = Constant.url_agent_transaction + "/" +  Constant.path_pending_transaction + "/" +  Constant.path_gold;
  public static url_agent_pending_buy_transaction = Constant.url_agent_pending_fund_transaction + "/" +  Constant.path_buy_transaction;
  public static url_agent_pending_sell_transaction = Constant.url_agent_pending_fund_transaction + "/" +  Constant.path_sell_transaction;
  public static url_agent_pending_transfer_buy_transaction = Constant.url_agent_pending_fund_transaction + "/" +  Constant.path_transfer_buy_transaction;
  public static url_agent_pending_transfer_sell_transaction = Constant.url_agent_pending_fund_transaction + "/" +  Constant.path_transfer_sell_transaction;

  public static url_agent_pending_buy_gold_transaction = Constant.url_agent_pending_gold_transaction + "/" +  Constant.path_buy_transaction;
  public static url_agent_pending_sell_gold_transaction = Constant.url_agent_pending_gold_transaction + "/" +  Constant.path_sell_transaction;
  public static url_agent_pending_withdraw_transaction = Constant.url_agent_pending_gold_transaction + "/" +  Constant.path_withdraw_transaction;

  public static url_agent_detail_transaction = Constant.url_agent_transaction + "/" + Constant.path_detail_transaction;
  public static url_agent_import_file = Constant.url_agent_transaction + "/" +  Constant.path_import_file_transaction;
  public static url_agent_import_file_new_transaction = Constant.url_agent_import_file + "/" + Constant.path_new_transaction;
  public static url_agent_import_file_check_status = Constant.url_agent_import_file + "/" + Constant.path_check_status;

  public static url_agent_history_transaction = Constant.url_agent_transaction + "/" + Constant.path_history_transaction;
  public static url_agent_transfer_asset = Constant.url_agent_transaction + "/" + Constant.path_transfer_asset;
  public static url_agent_statistic_transaction = Constant.url_agent_transaction + "/" + Constant.path_statistic_transaction;
  public static url_agent_admin_transaction = Constant.url_agent_transaction + "/" + Constant.path_admin_transaction;

  public static url_agent_reconcile_transaction = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_transaction + "/" +  Constant.path_reconcile;
  public static url_agent_reconcile_reconciled_transactions = Constant.url_agent_reconcile_transaction + "/" +  Constant.path_reconcile_transactions;
  public static url_agent_reconcile_agent_transaction_tabs = Constant.url_agent_reconcile_transaction + "/" +  Constant.path_reconcile_agent_transaction_tabs;
  public static url_agent_reconcile_vsd_transaction_tabs = Constant.url_agent_reconcile_transaction + "/" +  Constant.path_reconcile_vsd_transaction_tabs;

  public static url_agent_history_reconcile_transaction = Constant.url_agent_reconcile_transaction + "/" +  Constant.path_history_reconcile_transaction;

  public static url_agent_investors = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_investors;
  public static url_agent_investors_list = Constant.url_agent_investors + "/" + Constant.path_list;
  public static url_agent_investors_edit = Constant.url_agent_investors + "/" + Constant.path_edit;
  public static url_agent_investors_received_profile = Constant.url_agent_investors + "/" + Constant.path_received_profile;
  public static url_agent_investors_register_sip = Constant.url_agent_investors + "/" + Constant.path_register_sip;
  // public static url_agent_investors_change_profile = Constant.url_agent_investors + "/" + Constant.path_investors_change_profile;

  public static url_agent_user_doc = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_profile_investor + "/" + Constant.path_user_documents;
  public static url_agent_user_doc_kyc = Constant.url_agent_user_doc + "/" + Constant.path_kyc;
  public static url_agent_user_doc_kyc_for_foreign = Constant.url_agent_user_doc + "/" + Constant.path_kyc_for_foreign;
  public static url_agent_user_doc_vsd = Constant.url_agent_user_doc + "/" + Constant.path_vsd;
  public static url_agent_user_doc_approved_kyc_profile = Constant.url_agent_user_doc + "/" + Constant.path_approved_kyc_profile;
  public static url_agent_user_doc_pending_profile_on_vsd = Constant.url_agent_user_doc + "/" + Constant.path_pending_profile_on_vsd;
  public static url_agent_user_doc_profile_on_vsd = Constant.url_agent_user_doc + "/" + Constant.path_profile_on_vsd;
  public static url_agent_user_doc_list_not_updated_investors = Constant.url_agent_user_doc + "/" + Constant.path_list_not_updated_investors;
  public static url_agent_user_doc_survey_ipo = Constant.url_agent_user_doc + "/" + Constant.path_survey_ipo;
  public static url_agent_user_doc_list_ekyc_logs = Constant.url_agent_user_doc + "/" + Constant.path_list_ekyc_logs;
  public static url_agent_user_doc_list_ekyc_manual = Constant.url_agent_user_doc + "/" + Constant.path_list_ekyc_manual;

  public static url_agent_report = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_report;
  public static url_agent_asset_report = Constant.url_agent_report + "/" + Constant.path_asset_report;
  public static url_agent_fee_report = Constant.url_agent_report + "/" + Constant.path_fee_report;
  public static url_agent_fee_report_issuer = Constant.url_agent_report + "/" + Constant.path_fee_report_issuer;
  public static url_agent_fee_report_agent = Constant.url_agent_report + "/" + Constant.path_fee_report_agent;

  public static url_change_information = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_profile_investor + "/" + Constant.path_change_information;
  public static url_change_information_confirm_change_profile = Constant.url_change_information + "/" + Constant.path_investors_change_profile;
  public static url_change_information_confirm_change_name = Constant.url_change_information + "/" + Constant.path_investors_change_name;
  public static url_change_information_bank = Constant.url_change_information + "/" + Constant.path_change_information_bank;
  public static url_change_information_idCard = Constant.url_change_information + "/" + Constant.path_change_information_idCard;
  public static url_change_information_phone = Constant.url_change_information + "/" + Constant.path_change_information_phone;
  public static url_change_information_email = Constant.url_change_information + "/" + Constant.path_change_information_email;
  public static url_change_information_private = Constant.url_change_information + "/" + Constant.path_change_information_private;
  public static url_change_information_sign = Constant.url_change_information + "/" + Constant.path_change_information_sign;

  public static url_export_fatca = Constant.url_change_information + "/" + Constant.path_export_fatca;
  public static url_agent_register_sip = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_register_sip;

  public static url_agent_change_profile = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_change_profile;
  public static url_agent_change_profile_bank = "/" + Constant.path_account + "/" + Constant.code_agent + "/" + Constant.path_change_profile + "/bank-profile";
  public static url_agent_pending_profile = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_user_doc + "/" +  Constant.tab_pending_profile_on_vsd;
  public static url_agent_list_investor = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_user_doc + "/" +  Constant.tab_list_investor;
  public static url_agent_approved_profile = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_user_doc + "/" +  Constant.tab_approved_kyc_profile;

  public static url_agent_tools = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_tools + "/";
  public static url_agent_tools_split_pdf = Constant.url_agent_tools +  Constant.path_split_pdf;
  public static url_agent_tools_export_suggest_auto_payment = Constant.url_agent_tools +  Constant.path_export_suggest_auto_payment;
  public static url_agent_tools_check_asset = Constant.url_agent_tools +  Constant.path_check_asset;

  public static url_agent_products = "/" + Constant.path_account + "/" +  Constant.code_agent + "/" +  Constant.path_product;
  public static url_products_fund_list = Constant.url_agent_products + "/" + Constant.path_fund + "/list";
  public static url_products_gold_list = Constant.url_agent_products + "/" + Constant.path_gold + "/list";
  public static url_products_sip_list = Constant.url_agent_products + "/" + Constant.path_sip + "/list";
  public static url_products_nav_list = Constant.url_agent_products + "/" + Constant.path_nav + "/list";

  //Key localStorage
  public static key_local_token = "token";
  public static key_local_version = "version";
  public static key_local_language = "language";
  public static key_local_status = "status";
  public static key_local_first_login = "status";
  public static key_local_email = "emailFmarket";
  public static key_local_user_type = "type";
  public static key_local_login_sucess = "loginSuccess";
  public static key_local_current_screen = "currentScreen";
  public static key_local_current_tab_money = "money";
  public static key_local_current_create = "create";
  public static key_local_common_data = "data";
  public static key_local_current_tab_portfolio = "tabPortfolio";
  public static key_local_current_tab_transaction_history = "transaction";
  public static key_local_is_edit = "edit";
  public static key_local_is_draft = "draft";
  public static key_local_cms = "cms";
  //Data type
  public static data_type_languages = "languages";
  public static data_type_countries = "countries";
  public static data_type_issuerTypes = "issuerTypes";
  public static data_type_banks = "banks";
  public static data_type_asset_allocations = "assetAllocations";

  //Error code
  public static error_force_logout = 401;
  public static error_not_connect_server = 0;
  public static error_server_error = 500;
  public static error_server_maintenance = 503;
  public static error_code = 400;

  //Success code
  public static success_code = 200;
  public static no_content_code = 204;
  public static ERROR_CODE_RENEW_PASSWORD = 40027;

  //Default variable
  public static default_language = "vi_VN";
  //API key upload
  public static clientApiKey = "clientApiKey";
  public static clientApiKey_value = "FMARKET-ANGULAR";
  public static clientApiKey_value_report = "FMARKET-ANGULAR-KEY2";
  public static requestId = "requestId";
  public static fileType = "fileType";
  public static photoType = "photoType";
  public static base64File = "base64File";
  public static fileTypeNormal = "FILE";
  public static fileTypePhoto = "PHOTO";
  public static applyOriginalFileName = "applyOriginalFileName";

  //API
  // USER ACCOUNT
  public static api_auth_sign_up = "/auth/sign-up";
  public static api_auth_sign_in = "/auth/login";
  public static api_auth_log_out = "/users/logout";
  public static api_auth_sign_in_confirm = "/auth/login/confirm";
  public static api_auth_forgot_pass = "/auth/forgot-password";
  public static api_security_change_mail_1 = "/users/change-email1/step1/create";
  public static api_security_change_mail_2 = "/users/change-email2/step1/create";
  public static api_auth_reset_pass = "/auth/reset-password";
  public static api_user_sign_out = "/users/logout";
  public static api_user_profile = "/users/profile";
  public static api_user_change_pass = "/users/change-password";
  public static api_user_update_profile = "/users/profile";
  public static api_user_update_avatar = "/users/avatar";
  public static api_user_update_photos = "/users/passport-photos";
  public static api_user_update_mail = "/users/request-change-email";
  public static api_user_report_all_document = "/reports/funds";
  public static api_user_report_document_1 = "/reports/products/";
  public static api_user_report_document_2 = "/documents/filter";
  public static api_user_report_send_mail = "/reports/products/{productId}/broastcast";

  public static api_common = "/res/all";
  public static api_common_translations = "/res/translations?language=";
  public static api_common_issuer = "/res/issuers";
  public static api_common_agent_issuer = "/agents/issuers";
  public static api_common_bond_issuer = "/res/bond-issuers";
  public static api_common_cd_issuer = "/res/cd-issuers";
  public static api_common_asset_fund_export = "/investors/assets/fund-export";
  public static api_user_check_exists_name = "/auth/check-exists-nickname/";
  public static api_common_issuer_top = "/res/issuers/top";
  public static api_common_contact = "/home/contact-us";
  public static api_common_text_home = "/res/cms-block";
  public static api_common_social_type = "/res/social-types";
  public static api_common_document_file_investor = "/users/documents/"; //TODO productId;
  public static api_common_remove_file = "/reports/products/{productId}/documents/{documentId}"; //TODO productId;
  public static api_export_list_investor = "/agents/products/investor-list/export";
  public static api_common_following = "/home/subscribe";
  public static api_common_agent_products_filter = "/agents/products/filter";
  public static api_common_products_id = "/res/products/";
  public static api_export_id_card = "/agents/profile/passport-export";
  public static api_export_manulife = "/agents/sip/hsbc/new-user/export";
  public static api_get_report_products_filter = "/reports/products/filter";
  public static api_get_calculate_fee = "/agents/calculate-product-fee/filter";
  public static api_get_calculate_fee_issuer = "/agents/calculate-fee/issuer/filter";
  public static api_get_calculate_fee_partner = "/agents/calculate-fee/partner/filter";
  public static api_export_calculate_fee = "/agents/calculate-product-fee/export";
  public static api_export_calculate_fee_issuer = "/agents/calculate-fee/issuer/export";
  public static api_export_calculate_fee_partner = "/agents/calculate-fee/partner/export";
  public static api_get_statistic_gold_transaction = "/agents/stats-gold/filter";
  public static api_export_statistic_gold_transaction = "/agents/stats-gold/export";
  public static api_import_transaction = "/agents/order/import";
  public static api_import_transaction_test = "/agents/order/import/test";
  public static api_check_approve_status = "/agents/order/check-approve-status";
  public static api_import_split_pdf = "/agents/tools/splitPdf";
  public static api_import_check_asset = "/agents/check/holding-volume";
  public static api_export_suggest_auto_payment = "/agents/export-form-adjustment-info-investor";
  // Issuer
  public static api_issuer_create_product = "/products/fund";
  public static api_issuer_country_market = "/res/markets-currency?currencyCode="; //TODO currency code;
  public static api_issuer_issued_products = "/issuers/products/approval/filter";
  public static api_issuer_pending_products = "/issuers/products/pending/filter";
  public static api_issuer_approve_products = "/issuers/products/approved/filter";
  public static api_issuer_draft_products = "/issuers/products/draft/filter";
  public static api_issuer_gold_type = "/issuers/egold/egold-price-list";
  public static api_issuer_release_bond = "/res/bond-issuers";
  public static api_agencies_by_id = "/issuers/agents/approved/filter";
  public static api_issuer_cancel_pending_products = "/products/cancel";
  public static api_issuer_codes_order = "/issuers/orders/pending/codes";
  public static api_issuer_check_exists_name = "/products/check-exists-name";
  public static api_issuer_get_product = "/res/products";
  public static api_issuer_product_start_pending = "/products/start-editing";
  public static api_issuer_product_end_pending = "/products/end-editing";
  public static api_issuer_product_update_date = "/products/fund/update-expired-date";
  public static api_issuer_product_update_investing = "/products/cash/update-investing-value";
  public static api_issuer_product_cash_of_fund = "/products/cash/withdraw";
  public static api_issuer_product_save_edit_draft = "/products/fund/edit";
  public static api_upload_file = Constant.url_host_upload + "/file/upload";
  public static api_upload_file_register = Constant.url_host_upload + "/file/fileUploadClientSync";
  public static api_payment_interest = "/issuers/products/{productId}/pay-interest";
  public static api_payment_interest_noproduct = "/issuers/products/pay-interest";
  public static api_add_agent_into_issuer = "/issuers/agents/link";
  public static api_get_agents_approved = "/issuers/agents/approved/filter";
  public static api_issuer_transaction_history = "/issuers/transaction-history/filter";
  public static api_issuer_export_transaction_history = "/issuers/transaction-history/export";
  public static api_issuer_pending_trade = "/issuers/orders/pending/filter";
  public static api_issuer_export_pending_trade = "/issuers/orders/pending/export";
  public static api_user_social = "/reports/socials/"; //TODO ID;
  public static api_update_about_us = "/users/about-us"; //TODO ID;
  // Agent

  public static api_get_pending_profiles = "/agents/investment-profiles/pending/filter";
  public static api_get_pending_profiles_export = "/agents/investment-profiles/pending/export";
  public static api_get_profiles_export = "/agents/investor-profile/pending/export";
  public static api_get_pending_profiles_vsd_export = "/agents/investment-profiles/vsd/export";
  public static api_get_approve_profiles = "/agents/investment-profiles/approved/filter";
  public static api_get_document_survey_ipo = "/agents/document-survey-ipo/filter";
  public static api_get_approve_profiles_export = "/agents/investment-profiles/approved/export";
  public static api_get_investor_profiles_export = "/agents/investor-profile/pending/export";
  public static api_get_change_profiles_export = "/agents/investment-profile-change-requests/pending/export";
  public static api_get_change_id_card_export = "/agents/profile/export-passport-by-profile";
  public static api_get_issuer_agent = "/agents/get-issuers-by-agent";
  public static api_accept_profile = "/agents/investment-profiles/accept";
  public static api_approve_profile = "/agents/investment-profiles/approve";
  public static api_cancel_profile = "/agents/investment-profiles/cancel";
  public static api_remove_profile = "/agents/investment-profiles/remove-vsd-status/";
  public static api_update_status_profile = "/agents/investor-profile/update-status";
  public static api_update_create_file_to_vsd = "/agents/investment-profile/move-to-vsd-processing";
  public static api_update_update_to_vsd = "/agents/investment-profile/update-to-vsd";
  public static api_change_request_profile_filter = "/agents/investment-profile-change-requests/pending/filter";
  public static api_change_request_profile_approve = "/agents/investment-profile-change-requests/approve";
  public static api_change_request_profile_reject = "/agents/investment-profile-change-requests/cancel";
  public static api_profile_reject = "/agents/investor/reject/";
  public static api_agent_orders = "/agents/orders/pending/filter";
  public static api_export_agent_orders = "/agents/orders/pending/export";
  public static api_agent_transaction_detail = "/agents/orders/pending/detail/filter";
  public static api_agent_transaction_detail_export = "/agents/orders/pending/detail/export";
  public static api_agent_transaction_detail_export_sip_hsbc = "/agents/orders/sip/hsbc/export";
  public static api_agent_transaction_detail_export_vsd = "/agents/orders/pending/vsd/export";
  public static api_agent_transaction_detail_export_vsd_sip_daichi = "/agents/orders/pending/vsd/sip_dfvn/export";
  public static api_agent_transaction_detail_export_sr45_46 = "/agents/orders/pending/sr45-46/export";
  public static api_agent_register_sip = "/agents/sip/pending/detail/filter";
  public static api_agent_register_sip_export = "/agents/sip/pending/vsd/export";
  public static api_agent_register_sip_on_vsd = "/agent/sip/update";
  public static api_agent_statistic = "/issuers/asset-stats/filter";
  public static api_agent_statistic_export = "/issuers/asset-stats/export";
  public static api_agent_product_cancel_all = "/agents/orders/cancel-all";
  public static api_agent_product_accept_all = "/agents/orders/accept-all";
  public static api_agent_product_accept = "/agents/orders/accept";
  public static api_agent_product_approve = "/agents/orders/approve";
  public static api_agent_product_approve_all = "/agents/orders/approve-all";
  public static api_agent_product_cancel_order = "/agents/orders/cancel";
  public static api_agent_order_accept_all_summary = "/agents/orders/accept-all/summary";
  public static api_agent_order_approve_all_summary = "/agents/orders/approve-all/summary";
  public static api_agent_product_pledge = "/agents/orders/pledge";
  public static api_agent_product_cancel_pledge = "/agents/orders/cancel-pledge";
  public static api_agents_list = "/res/get-agents-by-issuer";
  public static api_count_list_kyc_priority = "/agents/investor-profile/summary-kyc-priority";
  public static api_count_list_register_trade = "/agents/investment-profiles/pending/summary";
  public static api_count_list_change_request = "/agents/investment-profile-change-requests/pending/summary";
  public static api_count_pending_order = "/agents/orders/pending/summary";
  public static api_count_register_sip = "/agents/investment-profiles/sip/pending/summary";
  public static api_count_priority_kyc = "/agents/investor-profile/summary-kyc-priority";
  public static api_count_foreign_investor = "/agents/investor-profile/summary-kyc-foreign-user";
  public static api_agent_name_orders = "/agents/orders/pending/products";
  public static api_agent_transaction_history = "/agents/transaction-history/filter";
  public static api_agent_export_transaction_history = "/agents/transaction-history/export";
  public static api_agent_transfer_asset_in_preview = "/agents/orders/transfer-asset/in/preview";
  public static api_agent_transfer_asset_in = "/agents/orders/transfer-asset/in";
  public static api_agent_transfer_asset_out_preview = "/agents/orders/transfer-asset/out/preview";
  public static api_agent_transfer_asset_out = "/agents/orders/transfer-asset/out";
  public static api_agent_transfer_asset_filter = "/agents/orders/transfer-asset/filter";
  public static api_agent_holding_asset_user = "/agents/investment-profiles/{profileNumber}/products-holding";
  public static api_agent_ekyc_log_list = "/agents/ekyc-log/list";
  public static api_agent_ekyc_manual_list = "/agents/ekyc-manual/list";
  public static api_agent_count_ekyc_manual_list = "/agents/ekyc-manual/summary";
  public static api_agent_list_sign_document_update_profile = "/agents/esign-change-personal-info-investors/filter";
  public static api_agent_approve_sign_document_update_profile = "/agents/esign-confirm-change-info-investors/approve";
  public static api_get_investment_profile_approved = "/agents/investment-profiles/approved/filter";
  public static api_get_investor_profile_pending = "/agents/investor-profile/pending/filter";
  public static api_investors_list = "/agents/investor/filter";
  public static api_asset_report = "/agents/products/asset/filter";
  public static api_asset_report_export = "/agents/products/asset/export";
  public static api_agent_investor_change_name_list = "/agents/users-update-name/filter";
  public static api_agent_approve_investor_change_name = "/agents/users-update-name/update";
  public static api_agent_order_list = "/agents/admin/order/list/";
  public static api_agent_sip_register_list = "/agents/admin/userAutomaticInvestmentRegister/list/";
  public static api_agent_sip_register = "/agents/admin/userAutomaticInvestmentRegister/";
  public static api_agent_query_vsd_reconcile= "/vsdReconcileHistory/";
  public static api_agent_query_change_profile = "/agents/admin/investmentProfileChangeLog/list/";
  public static api_agent_approve_change_profile = "/agents/admin/investmentProfileChangeLog/approve/";
  public static api_agent_reject_change_profile = "/agents/admin/investmentProfileChangeLog/reject/";
  public static api_agent_nav_change_list = "/productNav/v2/nav-change/list";

  public static api_get_export_hsbcAgent = "/orderReconcileHsbcAgent/upload";
  public static api_get_export_hsbc_balance = "/hsbcBalance/upload";
  public static api_get_export_upload_r44 = "/orderReconcileVsd/upload";
  public static api_get_export_hsbc_upload = "/orderReconcileHsbc/upload";
  public static api_get_export_upload_reconlied = "/orderReconcile/upload";
  public static api_get_export_vsd_upload = "/vsdBalance/upload";
  public static api_get_export_product_vsd = '/agents/vsd/assign-fund-by-product/export';
  public static api_get_export_fatca =  '/agents/investment-profile-change-requests/export-fatca';
 
  //Upload report
  public static api_report_add = "/reports/products/{productId}/documents";
  public static api_report_update = "/users/update-portfolio-info/new";
  //Const url icon
  public static icon_host = Constant.icon_url_host;
  public static icon_url_loading = Constant.icon_host + "loading.svg";
  public static icon_url_close = Constant.icon_host + "close.png";
  public static icon_url_close_no_backround = Constant.icon_host + "close_no_backround.png";
  public static icon_url_warning = Constant.icon_host + "warning.svg";
  public static icon_url_logo = Constant.icon_host + "logo.png";
  public static icon_url_logo_w = Constant.icon_host + "logo-w.png";
  public static icon_picture_default = Constant.icon_host + "user.png";
  public static icon_url_send_mail_done = Constant.icon_host + "sendMail.svg";
  public static icon_url_upload = Constant.icon_url_host + "upload.png";
  public static icon_url_delete_btn = Constant.icon_url_host + "delete-btn.png";
  public static icon_url_platform = Constant.images_url_host + "platform.png";
  public static logo_url_logo_1 = Constant.logo_url_host + "logo.svg";
  public static logo_url_logo_2 = Constant.logo_url_host + "logo-blue.svg";
  public static logo_url_logo_3 = Constant.logo_url_host + "new-logo-blue.svg";
  public static logo_url_logo_white = Constant.logo_url_host + "new-logo-white.svg";
  public static share_logo = Constant.logo_url_host + "logo-share.png";
  public static logo_blue = Constant.logo_url_host + "logo_blue.png";

  //Const
  public static const_refresh_select = "refresh";
  public static const_time_out_set_interval = 5;
  public static const_time_out_interval = 30 * 60;
  public static const_time_out_data_service = 60 * 1000;
  public static const_page_max_size = 1000;
  public static const_type_pdf = "PDF";
  public static const_type_excel = "XLS";
  public static const_pagerSize_default = 25;
  public static const_pagerSize_top_manager = 15;
  public static const_timeout = 300000;
  public static const_default_format_number = ".0-2";
  public static const_default_format_date = "dd/MM/yyyy";
  public static const_default_format_date_option = "dd/mm/yyyy";
  public static const_decimal_limit = 2;
  public static const_max_size_upload = 5 * 1024 * 1024;
  public static const_max_size_picture = 5 * 1024 * 1024;
  public static default_maxlenght = 254;
  public static default_maxlenght_about = 255;
  public static max_length = 40;
  public static max_length_name_product = 20;
  public static max_length_day = 17;
  public static min_length_password = 8;
  public static min_length_email = 4;
  public static max_length_description = 1000;
  public static max_length_name = 70;
  public static max_length_nickName = 16;
  public static KNOWLEDGE = "KNOWLEDGE";
  public static QA = "QA";
  public static FACEBOOK = "FACEBOOK";
  public static SKYPE = "SKYPE";
  public static TWITTER = "TWITTER";
  public static YOUTUBE = "YOUTUBE";
  public static MESSENGER = "MESSENGER";
  public static KAKAOTALK = "KAKAOTALK";
  public static WHATSAPP = "WHATSAPP";
  public static VIBER = "VIBER";
  public static WECHAT = "WECHAT";
  public static ZALO = "ZALO";
  public static ISSUER = "ISSUER";
  public static FUND_AGENT = "FUND_AGENT";
  public static BOND_AGENT = "BOND_AGENT";
  public static GOLD_AGENT = "GOLD_AGENT";
  public static CD_AGENT = "CERTIFICATE_OF_DEPOSIT_AGENT";
  public static INVESTOR = "INVESTOR";
  public static ORDER_PENDING = "ORDER_PENDING";
  public static ORDER_CARD = "ORDER_INIT";
  public static ORDER_CANCEL = "ORDER_CANCEL";
  public static ORDER_REJECT = "ORDER_REJECT";
  public static ORDER_APPROVE = "ORDER_APPROVE";
  public static ORDER_ACCEPT = "ORDER_ACCEPT";
  public static ORDER_RECONCILED = "ORDER_RECONCILED";
  public static ORDER_PLEDGE = "ORDER_PLEDGE";
  public static ORDER_CANCEL_PLEDGE = "ORDER_CANCEL_PLEDGE";
  public static PROFILE_PENDING = "INVESTMENT_PROFILE_PENDING";
  public static PROFILE_CANCEL = "INVESTMENT_PROFILE_CANCEL";
  public static PROFILE_ACCEPT = "INVESTMENT_PROFILE_ACCEPT";
  public static PROFILE_APPROVED = "INVESTMENT_PROFILE_APPROVE";
  public static PROFILE_REJECT = "INVESTMENT_PROFILE_REJECT";
  public static PROFILE_INIT = "INVESTMENT_PROFILE_INIT";
  public static CHANGE_PROFILE_APPROVED = "INVESTMENT_PROFILE_CHANGE_REQUEST_APPROVE";
  public static CHANGE_PROFILE_REJECT = "INVESTMENT_PROFILE_CHANGE_REQUEST_REJECT";
  public static CHANGE_PERSONAL_INFO_REQUEST_PENDING = "INVESTMENT_PROFILE_CHANGE_REQUEST_PENDING";
  public static FUND_ISSUER = "FUND_ISSUER";
  public static BOND_ISSUER = "BOND_ISSUER";
  public static BOND_FUND_ISSUER = "BOND_FUND_ISSUER";
  public static CERTIFICATE_OF_DEPOSIT_ISSUER = "CERTIFICATE_OF_DEPOSIT_ISSUER";
  // Regex
  public static REGEX_EMAIL = "/^w+@([0-9a-zA-Z]+.?)+$/";

  public static DAYS_OF_WEEK_WORKING_DAY = [1, 2, 3, 4, 5];

  public static MAX_FILE_SIZE = 8 * 1024 * 1024;
  public static extension_img = "jpg|JPG|jpeg|JPEG|tiff|TIFF|png|PNG|bmp|BMP|bgp|BGP|PPM|ppm|PGM|pgm|pbm|PBM|ico|ICO|PGF|pgf|IMG|img";
  public static extension_file_doc = "pdf|PDF|xls|XLS|xlsx|XLSX|doc|DOC|docx|DOCX|zip|ZIP|rar|RAR";

  //Product code
  public static CODE_ORDER_FUND = "FUND";
  public static CODE_NEW_FUND = "NEW_FUND";
  public static CODE_TRADING_FUND = "TRADING_FUND";
  public static CODE_GOLD = "GOLD";
  public static CODE_ORDER_CD = "CD";
  public static CODE_ORDER_GOLD = "GOLD";
  public static CODE_FIXED_INTEREST_ON_FIXED_CD = "FIXED_INTEREST_ON_FIXED_CD";
  public static CODE_FLEXIBLE_INTEREST_ON_FIXED_CD = "FLEXIBLE_INTEREST_ON_FIXED_CD";
  public static CODE_FLEXIBLE_CD = "FLEXIBLE_CD";
  public static CODE_ORDER_BOND = "BOND";
  public static CODE_BOND = "PRODUCT_BOND";
  public static CODE_FUND = "PRODUCT_FUND";
  public static CODE_CD = "PRODUCT_CD";
  public static CODE_MATURITY_BOND = "FLEXIBLE_YIELD_ON_FIXED_BOND";
  public static CODE_FIXED_BOND = "FIXED_BOND";
  public static CODE_FLEXIBLE_BOND = "FLEXIBLE_BOND";
  public static PRODUCT_CODE = "PRODUCT_FUND_NEW";
  public static PRODUCT_ACTIVE = "PRODUCT_ACTIVE";

  //withdrawal code
  // TODO status order
  public static CODE_CASH_PENDING = "CASH_PENDING";
  public static CODE_CASH_COMPLETE = "CASH_COMPLETE";
  public static CODE_CASH_CANCEL = "CASH_CANCEL";

  //Fee code
  public static BUY_FEE_CODE = "FEE_BUY";
  public static SELL_FEE_CODE = "FEE_SELL";
  //Order code
  public static CODE_ORDER_BUY = "BUY";
  public static CODE_ORDER_TRANSFER = "TRANSFER";
  public static CODE_ORDER_TRANSFER_BUY = "TRANSFER_BUY";
  public static CODE_ORDER_SELL = "SELL";
  public static CODE_ORDER_WITHDRAWAL = "WITHDRAW_GOLD";
  public static CODE_ORDER_TRANSFER_SELL = "TRANSFER_SELL";
  public static CODE_ORDER_PENDING = "PENDING";
  public static CODE_ORDER_ACCEPT = "ACCEPT";

  //Type cms text
  public static CMS_QA = "QA";
  public static CMS_USER_GUIDE = "USER_GUIDE";
  public static CMS_KNOWLEDGE = "KNOWLEDGE";
  public static CMS_HEADER = "HEADER";
  public static CMS_PORTFOLIO = "PORTFOLIO";
  public static CMS_GOOGLE_MAP = "GOOGLE_MAP";
  public static CMS_PLATFORM = "PLATFORM";
  public static CMS_FMARKET_PLATFORM = "FMARKET_PLATFORM";
  public static CMS_PLATFORM_TITLE = "PLATFORM_TITLE";
  public static CMS_PLATFORM_ICON = "PLATFORM_ICON";
  public static CMS_PLATFORM_CONTENT = "PLATFORM_CONTENT";
  public static CMS_PROCESS_INVESTOR = "PROCESS_INVESTOR";
  public static CMS_PROCESS_ISSUER = "PROCESS_ISSUER";
  public static CMS_HOWITWORK = "HOWITWORK";
  public static CMS_COMMON = "COMMON";
  public static CMS_COMMON_PHONE = "COMMON_PHONE";
  public static CMS_COMMON_EMAIL = "COMMON_EMAIL";
  public static CMS_LOCATION = "LOCATION";
  public static CMS_LEGAL_TERMS = "TERM";
  public static CMS_LEGAL_PRIVACY = "PRIVACY";
  public static CMS_LEGAL_DISCLOSURE = "DISCLOSURE";
  public static CMS_SLOGAN = "SLOGAN";
  public static CMS_INVESTOR_SLOGAN = "INVESTOR_SLOGAN";
  public static CMS_ISSUER_SLOGAN = "ISSUER_SLOGAN";
  public static CMS_ISSUER_TERM = "ISSUER_TERM";
  public static CMS_ISSUER_PRIVACY = "ISSUER_PRIVACY";
  public static CMS_ISSUER_LICENSE = "ISSUER_LICENSE";
  public static CMS_ISSUER_FAQ = "ISSUER_FAQ";
  public static CMS_INVESTOR_TERM = "INVESTOR_TERM";
  public static CMS_INVESTOR_PRIVACY = "INVESTOR_PRIVACY";
  public static CMS_INVESTOR_LICENSE = "INVESTOR_LICENSE";
  public static CMS_INVESTOR_FAQ = "INVESTOR_FAQ";
  public static CMS_OUR_STORY = "OUR_STORY";
  public static CMS_OUR_STORY_CONTENT = "OUR_STORY_CONTENT";
  public static CMS_OUR_STORY_HEADER = "OUR_STORY_HEADER";
  public static CMS_TRANSACTION = "TRANSACTION";
  public static CMS_HOTLINE = "HOTLINE";
  public static CMS_TIME = "TIME";
  public static CMS_QA_ISSUER = "QA_ISSUER";
  public static CMS_LICENSE = "LICENSE";
  public static CHAT = "CHAT";
  // public static CMS_TRANSACTION = 'TRANSACTION';

  public static checkMobile() { let check = false; (function (a) {   if (     /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(       a     ) ||     /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(       a.substr(0, 4)     )   )     check = true; })(navigator.userAgent || navigator.vendor); return window.screen.width < 768 ? check : false;
  }

  public static checkTablet() { let screen = window.screen.width; return screen >= 768 && screen <= 1024;
  }

  public static checkDateIssue(date) { let d = parseInt(date); let dayNow = new Date().getDate(); let monthNow = new Date().getMonth() + 1; let yearNow = new Date().getFullYear(); let day = new Date(d).getDate(); let month = new Date(d).getMonth() + 1; let year = new Date(d).getFullYear();
 if (yearNow === year) {   if (monthNow === month) {     return dayNow <= day;   } else return monthNow <= month; } else {   return yearNow <= year; }
  }

  // Dao: sua loi disable khi quy da qua ngay dao han
  public static checkMaturityIssue(date) { let d = parseInt(date); let dayNow = new Date().getDate(); let monthNow = new Date().getMonth() + 1; let yearNow = new Date().getFullYear(); let dayNext = new Date(d).getDate(); let monthNext = new Date(d).getMonth() + 1; let yearNext = new Date(d).getFullYear();
 if (yearNow === yearNext) {   if (monthNow === monthNext) {     return dayNow >= dayNext;   } else return monthNow >= monthNext; } else {   return yearNow >= yearNext; }
  }

  public static checkAndroid() { let userAgent = navigator.userAgent || navigator.vendor; return /android/i.test(userAgent);
  }

  public static checkIOS() { let userAgent = navigator.userAgent || navigator.vendor; if (/iPad|iPhone|iPod/.test(userAgent)) {   return "iOS"; }
  }

  public static getInputAcceptDocFile() { return Constant.extension_file_doc   .split("|")   .map((item) => "." + item)   .join(",");
  }

  public static getInputAcceptImgFile() { return Constant.extension_img   .split("|")   .map((item) => "." + item)   .join(",");
  }

  public static arraysEqual(a, b) { a = Array.isArray(a) ? a : []; b = Array.isArray(b) ? b : []; return a.length === b.length && a.every((el, ix) => el === b[ix]);
  }
}
